import {
  RecoilRoot,
  atom,
  useRecoilState,
  RecoilState
} from 'recoil';

import * as ht from './_ht';
import * as cr from './_cr';

const _RclRoot = (pd: {
  children: React.FC
}) => {
  return (
    cr.c(RecoilRoot, {
      key: 'Rcl.root'
    },
      pd.children
    )
  )
};
export default _RclRoot;

export const grtAtom = (
  pKey: string, 
  paItl: any
): RecoilState<ht.a> => {
  return atom({
    key: pKey,
    default: paItl,
  })
};

export const grtStt = (
  poAtom: RecoilState<ht.a>
) => {
  const _ls = useRecoilState(poAtom);
  return {
    clr: () => _ls[1]({}),
    crt: _ls[0],
    set: (pDz: { [_key: string]: ht.a}) => _ls[1]({ ..._ls[0], ...pDz })
  }
};
